var prongHorn = prongHorn || {};

prongHorn.presentation = prongHorn.presentation || function() {
    var $trigger = $('.presentation .js-readmore');
    var hiddenClass = 'presentation__text--hidden';
    var inActiveText = $trigger.first().text();
    var activeText = $trigger.first().data('toggle-text');



    this.init = function() {

        if($trigger.length) {

            $trigger.click(function(event) {
                event.preventDefault();
                var $this = $(this);
                var $textarea = $this.next('.presentation__text ');
                
                $textarea.slideToggle(600, function(el){

                    // Display text regarding to the state
                    if($textarea.is(':hidden')) {
                        $this.text(inActiveText)
                    } else {
                        $this.text(activeText)
                    }

                });


            });
            
        }


    };




    // Public functions
    return {
        init: init
    };

}(); 

